import { render, staticRenderFns } from "./backGroundCom.vue?vue&type=template&id=3d5860bf&scoped=true"
var script = {}
import style0 from "./backGroundCom.vue?vue&type=style&index=0&id=3d5860bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5860bf",
  null
  
)

export default component.exports